export default __webpack_public_path__ + "static/media/2408243.60440a35.webp";